// Ai-POS brand config. Cambiar aquí para rebranding total.
export const BRAND = {
  name: "Ai-POS",
  tagline: "Vende, controla y entiende tu negocio desde un solo lugar",
  logoText: "Ai-POS",
  domain: "ai-pos.cl",
};
